import { ButtonBase, CircularProgress, Stack, Typography } from "@mui/material";
import { MeetingQuestion, MeetingSurveyResponse } from "../../../types";
import { getQuestion } from "../../../types-helpers";

interface FillSurveyQuestionProps {
    questionNumber: number;
    questionId: string;
    pending?: boolean;
    startResponse?: MeetingSurveyResponse;
    onSurveyUpdated: (survey: MeetingQuestion) => void
}

const getColor = (response: String): string => {
    switch (response) {
        case MeetingSurveyResponse.StronglyAgree:
            return "#1b5e20";
        case MeetingSurveyResponse.Agree:
            return "#2e7d32";
        case MeetingSurveyResponse.SomeWhatAgree:
            return "#558b2f";
        case MeetingSurveyResponse.Neutral:
            return "#8d6e00";
        case MeetingSurveyResponse.SomeWhatDisagree:
            return "#e65100";
        case MeetingSurveyResponse.Disagree:
            return "#c62828";
        case MeetingSurveyResponse.StronglyDisagree:
            return "#7f0000";
        default:
            return "#616161";
    }
}

export const FillSurveyQuestion: React.FC<FillSurveyQuestionProps> = ({
    questionNumber,
    questionId,
    pending,
    startResponse,
    onSurveyUpdated,
}) => {

    const question = getQuestion(questionId);

    const options = Object.values(MeetingSurveyResponse)

    const selectOption = (option: MeetingSurveyResponse) => {
        onSurveyUpdated({
            questionId: questionId,
            surveyResponse: option,
        })
    }

    return (
        <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            sx={{ border: "1px solid #ccc", borderRadius: 2, p: 2, width: "100%" }}>
            <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                width={"100%"}>
                <Typography
                    variant="h5">
                    {`${questionNumber}). ${question.questionText}`}
                </Typography>
            </Stack>
            <Stack
                direction="row"
                flexWrap="wrap"
                justifyContent="center"
                sx={{ mt: 1 }}>
                {pending ? (
                    <Stack
                        direction="row"
                        alignItems="center"
                        spacing={1}
                        sx={{ py: 1.5 }}>
                        <CircularProgress size={18} />
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            Sending response...
                        </Typography>
                    </Stack>
                ) : (
                    options.map((option) => {
                        const color = getColor(option);
                        const selected = startResponse === option;
                        return (
                            <ButtonBase
                                key={option}
                                onClick={() => selectOption(option)}
                                focusRipple
                                sx={{
                                    m: 0.5,
                                    px: 1.5,
                                    py: 0.75,
                                    borderRadius: 1,
                                    backgroundColor: color,
                                    color: "#FFF",
                                    opacity: selected ? 1 : 0.5,
                                    boxShadow: selected ? `0 0 0 2px #fff, 0 0 0 4px ${color}` : "none",
                                    transition: "opacity 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                                    "&:hover": {
                                        opacity: 1,
                                    },
                                }}>
                                <Typography variant="body2" sx={{ fontWeight: 600, color: "#fff" }}>
                                    {option}
                                </Typography>
                            </ButtonBase>
                        );
                    })
                )}
            </Stack>
        </Stack >
    )
}

export default FillSurveyQuestion;